import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import {
  getDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue,
  setDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue,
} from "../../api/DeliveryCenter/deliveryCenter";
import LoadingBox from "../indicators/LoadingBox";
import { LightGreyBox } from "../styled";
import MoneyInput from "../Inputs/MoneyInput";
import { ButtonSuccessNoShadow } from "../styled/button";
import { dispatchSnackBarMessage } from "../../utils/snackbar";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../modals/AnimatedModal";
import AltRouteIcon from "@mui/icons-material/AltRoute";

export default function ShippingRoutesConfigModal({ show, closeModal }) {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!show) return;

    const loadData = async () => {
      try {
        const {
          data: { value },
        } = await getDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue();
        setValue(value / 100);
      } catch (e) {
        console.error(e);
        dispatchSnackBarMessage(
          `shipping-route-config-${Date.now()}`,
          "Erro ao carregar o valor da rota",
          "error"
        );
      }
    };

    loadData();
  }, [show]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await handleSetDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue();
      closeModal();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleSetDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue =
    async () => {
      try {
        setLoading(true);
        const obj = {
          value: parseFloat(value) * 100,
        };
        await setDeliveryCenterShippingRouteSecondayOrderDeliveryTaxValue(obj);

        const message = "Valor da rota atualizado com sucesso";
        dispatchSnackBarMessage(
          `shipping_route_secondary_order_delivery_tax_value-${new Date()}`,
          message,
          "success"
        );
      } catch (e) {
        const message =
          e.response?.data.error || "Erro ao atualizar valor da rota";
        dispatchSnackBarMessage(
          `shipping_route_secondary_order_delivery_tax_value-${new Date()}`,
          message,
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

  if (loading) {
    return <LoadingBox />;
  }

  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="40%"
      maxWidth="1000px"
    >
      <ModalHeader
        title="Valor da Rota"
        icon={AltRouteIcon}
        onClose={closeModal}
      />
      <ModalContent>
        <Box sx={{ p: 6 }}>
          <LightGreyBox>
            <MoneyInput value={value} setValue={setValue} />
          </LightGreyBox>
          <ButtonSuccessNoShadow
            type="submit"
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            sx={{ mt: 4 }}
          >
            Salvar
          </ButtonSuccessNoShadow>
        </Box>
      </ModalContent>
    </AnimatedModal>
  );
}
